import loadable from '@loadable/component';

export const OrgDashboardInvoiceBillingAddressContainerLoadable = loadable(
  () => import('./OrgDashboardInvoiceBillingAddressContainer'),
  {
    resolveComponent: (module) =>
      module.OrgDashboardInvoiceBillingAddressContainer,
  },
);
